import { isEmpty } from 'lodash';

import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT,
    RESET_FORM_SUBMIT_PAYMENT,
    PAYMENT_REQUEST_TYPE_IBAN,
    PAYMENT_REQUEST_TYPE_ASSOCIATION,
    PAYMENT_REQUEST_TYPE_EBON,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';
import { CALL_API } from '../../../../middlewares/api';

import { fetchPaymentRequestsIfNeeded } from '../ongoing/actions';

import { makeActionCreator } from '../../../../utils/actionsUtils';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_PAYMENT);

export const setTimeoutId = makeActionCreator(SET_TIMEOUT_ID, 'timeoutId');
export const clearTimeoutId = makeActionCreator(CLEAR_TIMEOUT_ID);

export function sendPaymentRequest(type, formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }

    let url;
    if (type === PAYMENT_REQUEST_TYPE_IBAN) {
        url = '/payment/iban';
    } else if (type === PAYMENT_REQUEST_TYPE_ASSOCIATION) {
        url = '/payment/association';
    } else if (type === PAYMENT_REQUEST_TYPE_EBON) {
        url = '/payment/ebon';
    } else {
        url = '/payment';
    }

    return {
        [CALL_API]: {
            endpoint: url,
            types: [
                REQUEST_FORM_SUBMIT_PAYMENT,
                SUCCESS_FORM_SUBMIT_PAYMENT,
                FAILURE_FORM_SUBMIT_PAYMENT
            ],
            body: formData,
            successCallback: (response, dispatch) => {
                dispatch(fetchPaymentRequestsIfNeeded(true));
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/actions.js